import { AntDesign } from "@expo/vector-icons";
import { Banner, useThemeProvider } from "@towersystems/roam-common-native";
import { useMemo } from "react";
import { BarcodeReaders } from "../../../../utilities/barcode-scanner/constants";

export interface ScannedBarcodeFormatBannerProps {
  format: string;
}

export function ScannedBarcodeFormatBanner({
  format,
}: ScannedBarcodeFormatBannerProps) {
  const { colors } = useThemeProvider();

  const formatLabel = useMemo(() => {
    const match = Object.values(BarcodeReaders).find(
      (reader) => reader.format === format
    );
    return match?.label || "Unknown";
  }, [format]);

  return (
    <Banner
      title={`Scanned barcode format: ${formatLabel}`}
      textProps={{ numberOfLines: 2 }}
      status="info"
      icon={<AntDesign name="infocirlce" size={20} color={colors.borderInfo} />}
    />
  );
}
